import { MapsAPILoader } from '@agm/core';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { GoogleService } from 'src/app/service/googleService';

@Component({
  selector: 'app-google-dropdown',
  templateUrl: './google-dropdown.component.html',
  styleUrls: ['./google-dropdown.component.scss']
})
export class GoogleDropdownComponent implements OnInit {
  autocompleteService: google.maps.places.AutocompleteService;
  placesService: google.maps.places.PlacesService;
  pickPlaces: google.maps.places.AutocompletePrediction[];
  placeDetails: google.maps.places.PlaceResult;
  @Output() lettersOnly = new EventEmitter;
  @Output() checkAddressDetail = new EventEmitter;
  @Output() placeDetailsEvent = new EventEmitter();
  @Input() childFormControlName: AbstractControl;
  @Input() id: any;
  sessionToken: any
  constructor(private mapsAPILoader: MapsAPILoader, public googleService: GoogleService) { }

  ngOnInit(): void {
    this.mapsAPILoader.load().then(() => {
      this.autocompleteService = new google.maps.places.AutocompleteService();
      this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
      this.sessionToken = new google.maps.places.AutocompleteSessionToken();
    });
  }
  customSearchFn(term: string, item) {
    // Off ng-select search feature
    return true;
  }
  onInputChangePickup(event: any) {
    if (event?.term?.length == 0) {
      this.pickPlaces = [];
    }
    if (((event?.term?.length % 3) == 0) || (event?.term?.length == 1)) {

      this.getPlacePredictions(event?.term, async predictions => {
        this.pickPlaces = predictions;
      });
    }
  }
  getPlaceDetails(placeId: any) {
    if (placeId) {
      const request: any = {
        placeId: placeId?.place_id,
        sessionToken: this.sessionToken,
        fields: ['name', 'formatted_address',
          'types',
          'geometry',
          'utc_offset_minutes',
          'url',
          'address_components', 'place_id']
      };

      this.placesService.getDetails(request, async details => {
        this.placeDetails = details;
        let googleDetails = await this.googleService.googleAddressLoad(this.placeDetails);
        this.placeDetailsEvent.emit(googleDetails);
      });
    }
    this.sessionToken = new google.maps.places.AutocompleteSessionToken();
  }
  getPlacePredictions(query: string, callback: (predictions: google.maps.places.AutocompletePrediction[]) => void) {
    const options: any = {
      // types: ['geocode'], // Restrict predictions to addresses only
      componentRestrictions: { country: ['in', 'au', 'sg', 'sl'] },
      language: 'en',
    };
    this.autocompleteService.getPlacePredictions({ input: query, sessionToken: this.sessionToken, ...options }, callback);
  }

  lettersOnlyClick(event: any) {
    this.lettersOnly.emit(event);
  }
  checkAddressDetails() {
    this.checkAddressDetail.emit();
  }
  handleInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const allowedSymbols = "!@#$%^&*()_-+=[]{};:'\"<>,.?/";
    const pattern = `[^a-zA-Z0-9\\s${allowedSymbols.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')}]`;
    const filteredInput = inputElement.value.replace(new RegExp(pattern, 'g'), '');
    inputElement.value = filteredInput;
  }
}
